var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof OrderSummaryUI !== "undefined") return resolve();
	__webpack_require__.l("https://order-summary-uimfe-prod.digital.business.comcast.com/orderSummaryUIRemoteEntry.js", function(event) {
		if(typeof OrderSummaryUI !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		__webpack_error__.event = event;
		reject(__webpack_error__);
	}, "OrderSummaryUI");
}).then(function() { return OrderSummaryUI; });